import type { ComponentProps } from 'react';
import { cx } from '../lib/cx';
import { Icon, type IconName } from './Icon';

interface ButtonProps extends ComponentProps<'button'> {
  readonly variant?: 'primary' | 'ghost';
  /** Trailing icon. */
  readonly icon?: IconName;
  /**
   * Keyboard shortcut shown after the label, such as "⌘ ↵". It is decorative; expose the
   * shortcut to assistive technology with `aria-keyshortcuts`.
   */
  readonly shortcut?: string;
}

export function Button({
  variant = 'ghost',
  icon,
  shortcut,
  className,
  children,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button type={type} className={cx('button', `button--${variant}`, className)} {...props}>
      <span className="button-label">{children}</span>
      {icon && <Icon name={icon} />}
      {shortcut && (
        <kbd className="kbd button-shortcut" aria-hidden="true">
          {shortcut}
        </kbd>
      )}
    </button>
  );
}
